import * as random from "./utils/random";
import { hex2rgba } from "./utils/color";
import { addFeature, FX_Features } from "./utils/features";
import canvasSketch from "canvas-sketch";
import p5 from "p5";

window.$fxhashFeatures = {};

// console.log(fxhash); // the 64 chars hex number fed to your algorithm
// console.log(fxrand()); // deterministic PRNG function, use it instead of Math.random()

// fxrand is a deterministic PRNG function, use it instead of Math.random()
// we set fxrand as new seed for random functions
random.set_seed(fxrand);

const settings = {
  dimensions: [3500, 3500],
  p5: { p5 },
  prefix: "reasons-to-be-cheerful",
};

addFeature(
  "Background Colour",
  "bgcolor",
  ["Dark", "Light", "Cool", "Hot"],
  [0.5, 0, 0, 0],
  ["#250000", "#9e9d90", "#7db9cb", "#f80174"]
);

addFeature(
  "Emitter Type",
  "emitterType",
  ["Star", "Flow"],
  [0.5, 0.5],
  ["star", "flow"]
);

addFeature(
  "Emitter Position",
  "emitterPosition",
  ["Grid", "Random"],
  [0.6, 0],
  ["grid", "random"]
);

addFeature(
  "Emitter Weight",
  "emitterWeight",
  ["Thick", "Medium", "Thin", "Invisible"],
  [0.2, 0, 0, 0.1],
  [3, 5, 20, 0]
);

addFeature(
  "Emitter Sizing",
  "emitterSizing",
  ["Random", "Regular"],
  [0, 0.6],
  ["random", "regular"]
);

addFeature(
  "Emitter Lifespan",
  "emitterLifespan",
  ["Short", "Medium", "Long", "Extra Long"],
  [0.1, 0.4, 0.4, 0.1],
  [0.2, 0.4, 0.7, 0.9]
);

addFeature(
  "Frame",
  "frame",
  ["Circluar", "Square", "None"],
  [0.4, 0.4, 0],
  ["circular", "square", "none"]
);

addFeature(
  "Palette",
  "palette",
  [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
  ],
  [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ],
  [
    ["#395a4f", "#432330", "#853c43", "#f25c5e", "#ffa566"],
    ["#c75233", "#c78933", "#d6ceaa", "#79b5ac", "#5e2f46"],
    ["#cc5d4c", "#fffec6", "#c7d1af", "#96b49c", "#5b5847"],
    ["#c5f7f0", "#a9c2c9", "#8e8ca3", "#72577c", "#562155"],
    ["#9e9393", "#5c5656", "#dbd3d3", "#c7d1af"],
    ["#d0cf75", "#f8764e", "#da2644", "#90044a", "#440a2a"],
    ["#a8ab9b", "#172a38", "#ec4b5d", "#f48773", "#e0c590"],
    ["#046d8b", "#309292", "#300692"],
    ["#f38a8a", "#55443d", "#440a2a"],
    ["#efffcd", "#dce9be", "#555152", "#2e2633", "#99173c"], //10
    ["#343838", "#005f6b", "#008c9e", "#00b4cc", "#00dffc"],
    ["#413e4a", "#73626e", "#b38184", "#f0b49e", "#f7e4be"],
    ["#fefe23", "#232323", "#6b3000", "#f9d423", "#ede574"],
    ["#99b898", "#fecea8", "#ff847c", "#e84a5f", "#2a363b"],
    ["#655643", "#80bca3", "#f6f7bd", "#e6ac27", "#bf4d28"],
    ["#ffffff", "#000000", "#eaeaea"],
    ["#351330", "#424254", "#64908a", "#e8caa4", "#cc2a41"],
    ["#554236", "#f77825", "#d3ce3d", "#f1efa5", "#60b99a"],
    ["#5d4157", "#838689", "#a8caba", "#cad7b2", "#ebe3aa"],
    ["#8c2318", "#5e8c6a", "#88a65e", "#bfb35a", "#f2c45a"], //20
    ["#fad089", "#ff9c5b", "#f5634a", "#ed303c", "#3b8183"],
    ["#fe4a49", "#0b156b", "#fed766", "#e6e6ea", "#f4f4f8"],
    ["#f8b195", "#f67280", "#c06c84", "#6c5b7b", "#355c7d"],
    ["#d1e751", "#ffffff", "#000000", "#4dbce9", "#26ade4"],
    ["#1b676b", "#519548", "#88c425", "#bef202", "#eafde6"],
    ["#5e412f", "#fcebb6", "#78c0a8", "#f07818", "#f0a830"],
    ["#bcbdac", "#cfbe27", "#f27435", "#f02475", "#3b2d38"],
    ["#452632", "#91204d", "#e4844a", "#e8bf56", "#e2f7ce"],
    ["#eee6ab", "#c5bc8e", "#696758", "#45484b", "#36393b"],
    ["#f0d8a8", "#3d1c00", "#86b8b1", "#f2d694", "#fa2a00"], //30
    ["#2a044a", "#0b2e59", "#0d6759", "#7ab317", "#a0c55f"],
    ["#f04155", "#ff823a", "#404017", "#fff7bd", "#95cfb7"],
    ["#b9d7d9", "#668284", "#2a2829", "#493736", "#7b3b3b"],
    ["#78755e", "#ccc68d", "#eedd99", "#eec290", "#854200"],
    ["#b3cc57", "#ecf081", "#ffbe40", "#ef746f", "#6d2c3d"],
    ["#a3a948", "#edb92e", "#f85931", "#ce1836", "#009989"],
    ["#300030", "#480048", "#601848", "#c04848", "#f07241"],
    ["#67917a", "#170409", "#b8af03", "#ccbf82", "#e33258"],
    ["#fd81dd", "#c4cbb7", "#ebefc9", "#eee0b7", "#362312"],
    ["#e8d5b7", "#0e2430", "#fc3a51", "#f5b349", "#e8d5b9"], //40
    ["#ab526b", "#362721", "#c5ceae", "#f0e2a4", "#f4ebc3"],
    ["#607848", "#333333", "#c0d860", "#f0f0d8", "#604848"],
    ["#4dfffd", "#c8d9bf", "#000000", "#ecdbbc", "#fedcba"],
    ["#a8e6ce", "#dcedc2", "#333333", "#ffaaa6", "#ff8c94"],
    ["#3e4147", "#fffedf", "#dfba69", "#5a2e2e", "#2a2c31"],
    ["#fc354c", "#29221f", "#13747d", "#0abfbc", "#fcf7c5"],
    ["#cc0c39", "#e6781e", "#c8cf02", "#f8fcc1", "#1693a7"],
    ["#1c2130", "#028f76", "#b3e099", "#ffeaad", "#d14334"],
    ["#a7c5bd", "#e5ddcb", "#eb7b59", "#cf4647", "#524656"],
    ["#dad6ca", "#1bb0ce", "#4f8699", "#6a5e72", "#563444"],
  ]
);

// Write the feature to the console
console.info("FXHash features:");
console.table(window.$fxhashFeatures);

const flatten = (arr) =>
  arr.reduce((list, v) => list.concat(Array.isArray(v) ? flatten(v) : v), []);

const rangeMap = (n, in_min, in_max, out_min, out_max) =>
  ((n - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;

const setPointsOnCircle =
  (vecFn) =>
  (numPoints, w, h, padding = 0) => {
    let points = new Array(numPoints).fill({});
    let arc = (Math.PI * 2.0) / numPoints; //arc in radians

    return points.map((point, i = 0) => {
      let angle = i * arc;
      let x = (w / 2 - padding) * Math.cos(angle) + w / 2; //2?
      let y = (h / 2 - padding) * Math.sin(angle) + h / 2;
      return vecFn(x, y);
    });
  };

const setPointsOnSquare = (w, h, padding = 0) => {
  return [
    { x: 0 + padding, y: 0 + padding },
    { x: w - padding, y: 0 + padding },
    { x: w - padding, y: h - padding },
    { x: 0 + padding, y: h - padding },
  ];
};

const createGrid = (rows, cols, w, h) => (fillCell) => {
  const gridRows = Array(rows).fill();
  const gridCols = Array(cols).fill();
  const cellWidth = w / gridCols.length;
  const cellHeight = h / gridRows.length;

  return gridRows.map((row, i) =>
    gridCols.map((col, j) =>
      fillCell(cellWidth * i, cellWidth * j, cellWidth, cellHeight)
    )
  );
};

const newCanvas = (grid) => (density, w, h) => {
  const canvasCell = (x, y, w, h) => {
    //Random sizing + opacity in draw creates the texture
    w = random.range(w * 1.3, w * 5);
    h = random.range(h * 1.3, h * 5);
    return { pos: { x, y }, size: { w, h } };
  };
  return flatten(grid(density, density, w, h)(canvasCell));
};

const canvasGrid = newCanvas(createGrid);

const flowField = (vecFn, noise, grid) => {
  const fieldCell = (x, y, w, h) => {
    const inc = 0.1;
    const angle = noise((x / w) * inc, (y / h) * inc) * (Math.PI * 2); //2D PERLIN NOISE
    const angleX = Math.cos(angle);
    const angleY = Math.sin(angle);

    return {
      pos: { x, y },
      size: { w, h },
      vec: vecFn(angleX, angleY).setMag(0.09),
    };
  };
  return grid(fieldCell);
};

const createEmitters =
  (vecFn) =>
  (grid) =>
  (setPoints) =>
  (size, type, position, weight, density, pointSize, pointLife) => {
    const emitterPosition = (position, x, y, w, h) => {
      const offset = vecFn(w / 2, h / 2);
      const ePos =
        position === "random"
          ? vecFn(
              random.range(0, settings.dimensions[0] - w),
              random.range(0, settings.dimensions[1] - h)
            )
          : vecFn(x, y);

      return ePos.add(offset);
    };

    const emitterSize = (size) => {
      let eSize = size === "random" ? random.range(200, 600) : 300;
      return { w: eSize, h: eSize };
    };

    const emitterPoints = (points, ePos, eSize) => {
      return points.map((pos, i) => {
        let arc = (Math.PI * 2.0) / points.length; //arc in radians
        let angle = i * arc;
        const offset = vecFn(eSize.w / 2, eSize.h / 2);
        return {
          color: random.pick(FX_Features["palette"]),
          type,
          opacity: 1,
          lifespan: 1000,
          acc: vecFn(0, 0),
          vel: vecFn(0, 0),
          vec: vecFn(Math.cos(angle), Math.sin(angle)).mult(-1),
          size: pointSize,
          pos: pos.add(ePos).sub(offset),
        };
      });
    };

    const emitter = (x, y, w, h) => {
      const ePosition = emitterPosition(position, x, y, w, h);
      const eSize = emitterSize(size);
      return {
        pos: ePosition,
        size: eSize,
        weight,
        color: random.pick(FX_Features["palette"]),
        points: emitterPoints(
          setPoints(vecFn)(density, eSize.w, eSize.h, eSize.w * 1.4),
          ePosition,
          eSize
        ),
      };
    };

    return flatten(grid(emitter));
  };

const applyForce = (field, width, height) => (emitters) => (cb) => {
  const updatePoints = (points) => {
    return points.map((point) => {
      const getCell = (x, y) => {
        const ix = Math.floor(x / 100);
        const iy = Math.floor(y / 100);
        return field[ix][iy];
      };

      const steerPoint = (point) => {
        const cell = getCell(point.pos.x, point.pos.y);
        point.type == "flow"
          ? point.acc.add(cell.vec)
          : point.acc.add(point.vec);
        return {
          ...point,
        };
      };

      const checkEdge = (point) => {
        point.pos.x = (point.pos.x + width) % width;
        point.pos.y = (point.pos.y + height) % height;
        return {
          ...point,
        };
      };

      const limitSpeed = (point) => {
        point.vel.limit(5);
        point.acc.mult(0);
        return {
          ...point,
        };
      };

      point = steerPoint(checkEdge(limitSpeed(point)));

      return {
        ...point,
        acc: point.acc,
        vel: point.vel.add(point.acc),
        vec: point.vec,
        pos: point.pos.add(point.vel),
      };
    });
  };

  return flatten(emitters.map((emitter) => updatePoints(cb(emitter.points))));
};

const reduceAndFade = (points) => {
  const reduceLifespan = (point) => {
    const lifespan =
      FX_Features["emitterType"] === "flow"
        ? FX_Features["emitterLifespan"] * 12
        : FX_Features["emitterLifespan"] * 5;
    point.opacity -= rangeMap(1, 0, lifespan, 0, 0.03);
    return { ...point };
  };
  points = points.map((point) => reduceLifespan(point));
  points = points.filter((point) => point.opacity > 0.01);

  return points;
};

const canvas = (grid) => (draw) => {
  grid.map((cell) => {
    draw.push();
    draw.rectMode("center");
    draw.noStroke();
    draw.translate(cell.pos.x, cell.pos.y);
    draw.fill(hex2rgba(random.pick(FX_Features["palette"]), 0.2));
    draw.rect(0, 0, cell.size.w, cell.size.h);
    draw.pop();
  });
};

const frame = (outer) => (inner) => (draw) => {
  draw.push();
  draw.noStroke();
  draw.beginShape();
  // Exterior part of shape, clockwise winding
  [...outer].reverse().map((point) => draw.vertex(point.x, point.y));
  draw.beginContour();
  inner.map((point) => draw.vertex(point.x, point.y));
  draw.endContour();
  draw.endShape();
  draw.pop();
};

const drawEmitters = (emitters) => (draw) => {
  emitters.map((emitter) => {
    draw.push();
    emitter.weight != 0 ? draw.fill(FX_Features["bgcolor"]) : draw.noFill();
    draw.strokeWeight(emitter.size.w / emitter.weight);
    emitter.weight != 0 ? draw.stroke(emitter.color) : draw.noStroke();
    draw.translate(emitter.pos.x, emitter.pos.y);
    draw.circle(0, 0, emitter.size.w, emitter.size.h);
    draw.pop();
  });
};

const drawEmitterPoints = (points) => (draw) => {
  if (points.length === 0) {
    draw.noLoop();
    fxpreview();
    return;
  } else {
    return points.map((point) => {
      draw.push();
      draw.noStroke();
      draw.translate(point.pos.x, point.pos.y);
      draw.rotate(point.vec.heading());
      draw.fill(hex2rgba(point.color, point.opacity));
      draw.ellipse(0, 0, point.size.w, point.size.h);
      draw.pop();
    });
  }
};

const sketch = ({ p5, width, height }) => {
  /* --- 
  Sketch setup 
  --*/
  p5.noiseSeed(random.value);
  p5.background(FX_Features["bgcolor"]);
  /* --- 
  Emitter settings 
  --*/
  const eSizing = FX_Features["emitterSizing"];
  const eType = FX_Features["emitterType"];
  const ePosition = FX_Features["emitterPosition"];
  const eWeight = FX_Features["emitterWeight"];
  const eDensity = 60;
  const ePointSize = { w: 15, h: 15 };

  const gridRes = 100; //closer to width lowers the resolution of the grid
  const canvasRes = 90; //higher produces tighter weave
  const rows = Math.floor(height / gridRes);
  const cols = Math.floor(width / gridRes);

  const vecFn = p5.createVector;

  const theGrid = createGrid(rows, cols, width, height);
  const theFlowField = flowField(vecFn, p5.noise, theGrid);
  const emitterGrid = createEmitters(vecFn)(createGrid(3, 3, width, height))(
    setPointsOnCircle
  );
  const emitters = emitterGrid(
    eSizing,
    eType,
    ePosition,
    eWeight,
    eDensity,
    ePointSize
  );

  const frameInner = (frameType) => {
    const frame =
      frameType === "square"
        ? setPointsOnSquare(width, height, 200)
        : setPointsOnCircle(vecFn)(60, width, height, 200);
    if (frameType != "none") {
      return frame;
    } else {
      return setPointsOnSquare(width, height);
    }
  };

  const animatePoints = applyForce(theFlowField, width, height);
  const drawCanvas = canvas(canvasGrid(canvasRes, width, height));
  const drawFrame = frame(setPointsOnSquare(width, height))(
    frameInner(FX_Features["frame"])
  );

  /*--
  DRAW
  --*/

  drawCanvas(p5);
  drawFrame(p5);

  p5.loop();
  return () => {
    drawEmitterPoints(animatePoints(emitters)(reduceAndFade))(p5);
    drawEmitters(emitters)(p5);
  };
};

canvasSketch(sketch, settings);
